import React from 'react'

const ScrollToTopButton = () => {

    return (
        <div className='position-fixed' style={{ bottom: '3%', right: '3%', zIndex: '100' }}>
            <button
                type='button'
                onClick={() => { window.scrollTo(0, 0) }}
                className='btn rounded-circle text-white scroll-to-top-button'
            >
                <i className="fa-solid fa-chevron-up scroll-to-top-icon"></i>
            </button>
        </div>
    )
}

export default ScrollToTopButton